<section class="aviso" aria-label="Nueva Localización instantánea">
  <div class="aviso__mensaje">
    <span class="aviso__etiqueta">NUEVO</span>
    <p class="aviso__texto">
      <strong class="aviso__titulo">Todo en un solo lugar: ¡Conoce la nueva Localización instantánea!</strong>
      Todas las funciones que usas hoy, con nuevos filtros y una visualización más clara. Este módulo dejará de estar disponible el día <strong>31 de octubre.</strong>
    </p>
  </div>
  <a class="aviso__boton" [href]="urlNuevoModulo">
    Ir al nuevo módulo<span class="material-symbols-rounded" aria-hidden="true">arrow_forward</span>
  </a>
  <button type="button" class="aviso__cerrar material-symbols-rounded" aria-label="Cerrar aviso" (click)="cerrar.emit()">close</button>
</section>
